export const THEME = Object.freeze({
  LIGHT: 'LIGHT',
  DARK: 'DARK',
})



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/widget/TakeoverCampaign/constants.js